// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2Ajiq","calendarButtons":"ClockData_calendarButtons__147wm"};